import { flow, identity, negate, every, toLower, words, filter } from 'lodash';

// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined'
    ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    : string;
}

const convertInput = flow(toLower, stripDiacritics);
const isFalsy = negate(identity);

export function multiWordfilterOptions(options, state) {
  const { inputValue, getOptionLabel } = state;
  const inputs = words(inputValue).map(convertInput);
  if (!inputs || inputs.length === 0 || every(inputs, isFalsy)) {
    return options;
  }

  const filteredOptions = filter(options, (option) => {
    const candidate = convertInput(getOptionLabel(option));
    return every(inputs, (input) => candidate.indexOf(input) > -1);
  });

  return filteredOptions;
}
